import $ from 'jquery'; 
import Swiper from 'swiper';
import { Pagination, Autoplay, Navigation} from 'swiper/modules';
import { min992, max992 } from "../utils";

const swiper = () => {

    const sliders = document.querySelectorAll(".testimonial-wrapper");

    if (sliders.length > 0) {
        sliders.forEach((slider) => {
        let count = slider.children.length;
        if (count >= 1) {
            const swiper = new Swiper(slider, {
                modules: [Pagination, Autoplay],
                autoplay: {
                    delay: 4000, //  4 seconds
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                fadeEffect: {
                    crossFade: true,
                },
                speed: 500,
                pagination: {
                    el: slider.querySelector(".swiper-pagination")
                },
                slidesPerView: 1,
                loop: true,

            });
        }
        });
    }

    const services = document.querySelectorAll(".Services-buyer");

    if (services.length > 0) {
        services.forEach((slider) => {
        let count = slider.children.length;
        if (count >= 1) {
            const swiper = new Swiper(slider, {
                modules: [Pagination, Autoplay, Navigation],
                autoplay: {
                    delay: 2000, //  4 seconds
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                fadeEffect: {
                    crossFade: true,
                },
                pagination: {
                    el: slider.querySelector(".swiper-pagination")
                },
                navigation: {
                    nextEl: slider.querySelector(".swiper-button-next"),
                    prevEl: slider.querySelector(".swiper-button-prev"),
                },
                speed: 500,
                slidesPerView: 4,
                spaceBetween: 24,
                loop: true,

                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    992: {
                        slidesPerView: 4,
                    },
                },
            });
        }
        });
    }

     const services_seller = document.querySelectorAll(".Services-seller");

    if (services_seller.length > 0) {
        services_seller.forEach((slider) => {
        let count = slider.children.length;
        if (count >= 1) {
            const swiper = new Swiper(slider, {
                modules: [Pagination, Autoplay, Navigation],
                autoplay: {
                    delay: 2000, //  4 seconds
                    disableOnInteraction: false,
                    reverseDirection: true,
                    pauseOnMouseEnter: true,
                },
                fadeEffect: {
                    crossFade: true,
                },
                pagination: {
                    el: slider.querySelector(".swiper-pagination")
                },
                navigation: {
                    nextEl: slider.querySelector(".swiper-button-next"),
                    prevEl: slider.querySelector(".swiper-button-prev"),
                },
                speed: 500,
                slidesPerView: 4,
                spaceBetween: 24,
                loop: true,

                breakpoints: {
                    0: {
                        slidesPerView: 1.2,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    992: {
                        slidesPerView: 4,
                    },
                },
            });
        }
        });
    }
}

export default swiper